import RouteComponent from "./setup/route.component";
import './App.css';

//Login depdencies
import { googleLogout, useGoogleLogin } from '@react-oauth/google';
import { useLayoutEffect, useState } from "react";
import { getauth } from "./redux/services/user";
import Login from "./setup/login";
import { toast } from "react-toastify";


const toatconfig = {
  // position: toast.POSITION.TOP_RIGHT, // Position of the toast
  autoClose: 2000, // Auto close duration in milliseconds
  hideProgressBar: true, // Whether to hide the progress bar
  closeOnClick: true, // Close the toast when clicked
  pauseOnHover: false, // Pause auto close on hover
  draggable: false, // Allow dragging the toast
  // progress: undefined, // Custom progress indicator
  // theme: "colored", // Theme of the toast notification
}


function App() {

  const [isAuthenticated, setisAuthenticated] = useState(false)
  useLayoutEffect(() => { //check login on refresh
    setisAuthenticated(JSON?.parse(sessionStorage.getItem("isAuthenticated")))
  }, [])

  // google Login
  const handleGoogleLogin = useGoogleLogin({
    onSuccess: tokenResponse => {
      fetch(`https://www.googleapis.com/oauth2/v2/userinfo?access_token="${tokenResponse.access_token}".`)
        .then(response => response.json())
        .then(data => {
          if (data?.email != undefined && data?.email != null) {
            getauth({
              userEmail: data?.email
            }).then((response) => {
              if (response?.data == true) {
                // console.log('response?.data: ', response?.data);
                // console.log('data: ', data);
                // sessionStorage.setItem("userInfo", JSON.stringify(data));
                sessionStorage.setItem("isAuthenticated", !!data);
                sessionStorage.setItem("userEmailId", `${data?.email}`);
                // sessionStorage.setItem("userName", `${data?.name}`);
                // dispatch(setState({ userData: data }))
                toast.success("Logged in Successfully", toatconfig);
                setisAuthenticated(true)
              } else {
                // console.log('✌️response --->', 'false');
                toast.error("Loggin Failed, Please Contact Administrator", toatconfig);
              }
            }).catch((error) => {
              if (!error.response) toast.error("Please Check your Network or Contact Administrator", toatconfig);
              else {
                // console.log('✌️error --->', error);
                toast.error("Loggin Failed, Please Contact Administrator", toatconfig);
              }
            });
          }
        })
        .catch(error => console.log(error));
    },

  });

  const handleGoogleLogout = async () => {
    try {
      await googleLogout();

      // sessionStorage.removeItem("userInfo")
      sessionStorage.removeItem("userEmailId");
      sessionStorage.setItem("isAuthenticated", false)
      // sessionStorage.removeItem("userName");
      // dispatch(setState({ userData: {} }))
      // navigate('/')
      // toast.success("Logged out Successfully", toatconfig);
      // Handle successful logout
    } catch (error) {
      // Handle logout error
      console.error('Logout error:', error);
      // Perform any necessary cleanup or error handling
    }
  };


  // return isAuthenticated ? <RouteComponent /> : <Login login={handleGoogleLogin} />
  return <RouteComponent />
}

export default App;
